import { MetadataDataType } from 'generated/graphql';

export const getDisplayNameForMetadataType = (
  metadataType: MetadataDataType,
) => {
  switch (metadataType) {
    case MetadataDataType.Number:
      return 'Number';
    case MetadataDataType.Boolean:
      return 'Boolean';
    case MetadataDataType.String:
      return 'String';
    case MetadataDataType.DateTime:
      return 'Date Time';
    default:
      return 'Unknown';
  }
};
